export enum FilterType {
  startsWith,
  contains
}
